import z from "zod/v4";

import { parseRowsTolerantly } from "../../shared/schemas/paginated-list";

const OperatorSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  crmCustomerId: z.number().int().nullish(),
});

const OperatorsResponseSchema = z
  .object({ operators: z.array(z.unknown()).nullish() })
  .transform((envelope) =>
    parseRowsTolerantly(OperatorSchema, envelope.operators ?? [], "operator")
  );

type Operator = z.infer<typeof OperatorSchema>;

export { OperatorSchema, OperatorsResponseSchema };
export type { Operator };
